export default __webpack_public_path__ + "static/media/Strangler's Armbands of the Hidden Tomb.a1ef165c.jpg";